import * as API from './api'
import * as Types from './Types'
import * as Strings from './strings'
import * as Constants from '../helpers/Constants'

export function tryCreateBookingForBookingSystem(
  token,
  systemId,
  data,
  offline,
  alert,
  language
) {
  if (offline) {
    return dispatch => {
      dispatch({
        type: Types.CREATE_BOOKING_FOR_BOOKING_SYSTEM_SUCCESS,
        payload: {
          data: {
            id: generateId(),
            bookableId: systemId,
            bookableTimeId: data.timeId,
            date: data.date,
            status: 'open',
            apartmentId: 1
          },
          systemId,
          loading: data
        }
      })
    }
  }

  return dispatch => {
    dispatch({
      type: Types.CREATE_BOOKING_FOR_BOOKING_SYSTEM,
      payload: data
    })

    API.createBookingForBookingSystem(token, systemId, data)
      .then(response => {
        dispatch({
          type: Types.CREATE_BOOKING_FOR_BOOKING_SYSTEM_SUCCESS,
          payload: { data: response.data.data, systemId, loading: data }
        })
      })
      .catch(error => {
        if (error.response && error.response.status === 400) {
          console.log(language)
          alert(
            Strings.default.MAX_BOOKINGS_REACHED[language],
            Strings.default.MAX_BOOKINGS_REACHED_INFO[language],
            Constants.ONE_BUTTON,
            {
              title: Strings.default.OK[language],
              onPress: () => {}
            }
          )
        }
        dispatch({
          type: Types.CREATE_BOOKING_FOR_BOOKING_SYSTEM_FAILED,
          payload: { status: 500, loading: data }
        })
      })
  }
}

export function tryDeleteBookingForBookingSystem(
  token,
  systemId,
  bookingId,
  offline
) {
  if (offline) {
    return dispatch => {
      dispatch({
        type: Types.DELETE_BOOKING_FOR_BOOKING_SYSTEM_SUCCESS,
        payload: { bookingId, systemId }
      })
    }
  }

  return dispatch => {
    dispatch({
      type: Types.DELETE_BOOKING_FOR_BOOKING_SYSTEM,
      payload: bookingId
    })

    API.deleteBookingForBookingSystem(token, systemId, bookingId)
      .then(() => {
        dispatch({
          type: Types.DELETE_BOOKING_FOR_BOOKING_SYSTEM_SUCCESS,
          payload: { bookingId, systemId }
        })
      })
      .catch(() => {
        dispatch({
          type: Types.DELETE_BOOKING_FOR_BOOKING_SYSTEM_FAILED,
          payload: { status: 500, bookingId }
        })
      })
  }
}

function generateId() {
  return Math.floor(Math.random() * 1000000 + 1) // This may generate a duplicate key but I deem the odds of that to be fairly low.
}



// WEBPACK FOOTER //
// ./src/actions/BookingSystemBookings.js